/**
 * @module components\TxnHistory
 */
import core from '@/services/core';
import store from '@/store';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { required } from "vuelidate/lib/validators";

@Component
export default class TransactionInfo extends Vue {
  detailsHeaders=store.getters.transInfoGet.transInfo.headers;
  detailsValues=store.getters.transInfoGet.transInfo.historyData;
  back(){
    this.$router.push({name:'txnHis'});
  };
  getStatusColor(status){
    switch (status.toUpperCase()) {
      case 'SUCCESS':
        return 'color:#34a853';
      case 'FAILED':
        return 'color:#ea4335';
      case 'PENDING':
      case 'INITIATED':
        return 'color:#293896';
      default:
        return '';
    }
  }
}
